import BaseAPI from 'api/api'
import { FindAllInterface } from 'api/api-interface'
/** UTIILS */

export interface CareerLineInterface {
  careerLineName: string
  careerLineNameEn?: string
  status: string
}

export default class CareerLineApi extends BaseAPI {
  static findAll(props: FindAllInterface): Promise<any> {
    return this.api.get('career-lines', { params: { ...props } }).then((res) => res)
  }

  static create(careerLineName: string, careerLineNameEn: string) {
    return this.api.post('career-lines', { careerLineName, careerLineNameEn })
  }

  static findById(id: number): Promise<CareerLineInterface> {
    return this.api.get(`career-lines/${id}`)
  }

  static update(id: number, body: CareerLineInterface) {
    return this.api.patch(`career-lines/${id}`, body)
  }

  static updateStatus(id: number, status: string): Promise<any> {
    return this.api.patch(`career-lines/${id}/status`, { id, status })
  }

  static remove(id: number) {
    return this.api.delete(`career-lines/${id}`)
  }
}
